import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from 'libs/portal/src/layout/layout.component';
import { AuthGuardService } from 'libs/portal/src/services/auth-guard/auth-guard.service';
import { UserRightsAuthGuardService } from 'libs/portal/src/services/user-rights-auth-guard.service';

const routes: Routes = [
  {
    path: 'Dashboard',
    component: LayoutComponent,
    data: { breadcrumb: 'Dashboard' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('libs/portal/src/modules/relay/pages/relay-dashboard/relay-dashboard.module').then((m) => m.RelayDashboardModule),
        canActivate: [AuthGuardService, UserRightsAuthGuardService],
      },
      {
        path: 'Details',
        data: {breadcrumb: 'Details' },
        pathMatch: 'full',
        loadChildren: () => import('libs/portal/src/modules/relay/pages/relay-transaction-detail/relay-transaction-detail.module').then((m) => m.RelayTransactionDetailModule),
        canActivate: [AuthGuardService, UserRightsAuthGuardService],
      },
      {
        path: 'PortsManagement',
        data: {breadcrumb: 'Ports Management' },
        pathMatch: 'full',
        loadChildren: () => import('libs/portal/src/modules/relay/pages/relay-port-management/relay-port-management.module').then((m) => m.RelayPortManagementModule),
        canActivate: [AuthGuardService, UserRightsAuthGuardService],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuardService],
})
export class RelayRoutingModule {}
